import React from 'react';
import { Edit2, Mail } from 'lucide-react';
import { EntityStatusBadge } from './EntityStatusBadge';
import { EntityStatusToggle } from './EntityStatusToggle';
import { API_BASE_URL as API_URL } from '../utils/api';

const UserCard = ({ user, onEdit, onToggleStatus, toggling }) => (
  <div className="bg-white rounded-lg shadow-md p-5 hover:shadow-xl transition-shadow relative overflow-hidden min-h-[200px] flex flex-col">
    <div className="flex items-start justify-between mb-4 gap-3">
      <div className="flex items-center gap-3 min-w-0 flex-1">
        {user.profileImage ? (
          <img
            src={`${API_URL}${user.profileImage}`}
            alt={`${user.firstName} ${user.lastName}`}
            className="w-14 h-14 rounded-full object-cover border-2 border-gray-200 flex-shrink-0"
          />
        ) : (
          <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white text-xl font-bold flex-shrink-0">
            <span>{user.firstName?.[0]}{user.lastName?.[0]}</span>
          </div>
        )}
        <div className="min-w-0 flex-1">
          <h3 className="text-base font-bold text-gray-800 flex items-center gap-2 flex-wrap">
            <span className="truncate">{user.firstName} {user.lastName}</span>
            <EntityStatusBadge isActive={user.isActive} />
          </h3>
          <p className="text-xs text-gray-500 flex items-center gap-1 mt-0.5 truncate">
            <Mail className="w-3 h-3 flex-shrink-0" /> <span className="truncate">{user.username}</span>
          </p>
          {user.displayId && (
            <span className="inline-block mt-1 text-xs font-mono bg-gray-100 text-gray-600 px-2 py-0.5 rounded">
              #{user.displayId}
            </span>
          )}
        </div>
      </div>
      <div className="flex gap-2 flex-shrink-0">
        <button
          onClick={() => onEdit(user)}
          className="w-10 h-10 flex items-center justify-center bg-blue-100 text-blue-700 hover:bg-blue-200 rounded-lg transition-colors"
          title="Redaktə et"
        >
          <Edit2 className="w-4 h-4" />
        </button>
        <EntityStatusToggle entity={user} onToggle={onToggleStatus} loading={toggling} />
      </div>
    </div>
  </div>
);

export default UserCard;
